import { render, staticRenderFns } from "./SvIcon.vue?vue&type=template&id=3734dcbe&lang=pug&"
import script from "./SvIcon.vue?vue&type=script&lang=js&"
export * from "./SvIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports